import { useState, useEffect } from "react";
import ConfirmationDialog from "./ConfirmationDialog";
import { registerDialogHandler } from "./DialogService";

export const ConfirmationDialogProvider = ({ children }) => {
  const [state, setState] = useState({
    isOpen: false,
    info: null,
    yesFun: null,
  });

  useEffect(() => {
    registerDialogHandler((info, yesFun) => {
      setState({ isOpen: true, info, yesFun });
    });
  }, []);

  const handleClose = () => {
    setState({ isOpen: false, info: null, yesFun: null });
  };

  const handleConfirm = (info) => {
    if (state.yesFun) state.yesFun(info);
    handleClose();
  };

  return (
    <>
      {children}
      <ConfirmationDialog
        isOpen={state.isOpen}
        info={state.info}
        onClose={handleClose}
        onConfirm={handleConfirm}
      />
    </>
  );
};
